var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMan(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 103,
    viewBox: "0 0 89 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.9148 81.2979L48.7446 92.1489H40.0638L37.8936 81.2979",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9148 100.83L48.7446 92.1489H40.0638L37.8936 100.83",
    stroke: "#E37021",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.383 57.4253V66.1061H29.2127L22.7021 72.6168L11.8315 77.7341C5.97412 79.2533 1.11068 83.5199 1 87.8083V103",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M66.1062 20.5319V24.8723L70.4466 27.0425V35.5714C70.4466 37.0233 69.7218 38.3775 68.513 39.1827L66.1062 42.234C66.1062 42.234 66.1062 45.6369 66.1062 46.5744C66.1062 54.984 54.9839 58.6473 53.0849 59.5957C51.186 60.5441 47.9307 61.7659 44.4041 61.7659C40.8775 61.7659 37.6222 60.5441 35.7233 59.5957C33.8243 58.6473 22.702 54.984 22.702 46.5744C22.702 45.5653 22.702 42.234 22.702 42.234L20.2952 39.1827C19.0864 38.3775 18.3616 37.0233 18.3616 35.5714V27.0425L22.702 24.8723V20.5319C22.702 9.74378 31.4458 1 42.2339 1H46.5743C57.3624 1 66.1062 9.74378 66.1062 20.5319Z",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3833 66.1064L44.4046 76.9575",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4045 76.9576L33.5534 85.6385L22.7024 72.6172",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4255 57.4253V66.1061H59.5957L66.1064 72.6168L76.977 77.7341C82.8344 79.2533 87.6978 83.5199 87.8085 87.8083V103",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M57.4253 66.1064L44.4041 76.9575",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4041 76.9576L55.2551 85.6385L66.1062 72.6172",
    stroke: "#0061AA",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMan);
export default __webpack_public_path__ + "static/media/man.447bb6c3be232370a8895ad52afbb427.svg";
export { ForwardRef as ReactComponent };